import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../ModuleSubtopic";

const ALL_CVLA_SUBTOPICS = [
    { name: 'Analytic function', path: '/cvla-m1-s1' },
    { name: 'Harmonic conjugate', path: '/cvla-m1-s2' },
    { name: 'Milne Thomson method', path: '/cvla-m1-s3' },
    { name: 'Polar form', path: '/cvla-m1-s4' },
    { name: 'Application in analytic function', path: '/cvla-m1-s5' },
    { name: 'Elementary Transformations in Conformal Mapping', path: '/cvla-m2-s1' },
    { name: 'Special transformation', path: '/cvla-m2-s2' },
    { name: 'Bilinear transformation', path: '/cvla-m2-s3' },
    { name: 'Taylor\'s series', path: '/cvla-m3-s1' },
    { name: 'Laurent\'s series', path: '/cvla-m3-s2' },
    { name: 'Cauchy Integral formula', path: '/cvla-m3-s3' },
    { name: 'Singularity and poles', path: '/cvla-m3-s4' },
    { name: 'Cauchy residue theorem', path: '/cvla-m3-s5' },
    { name: 'Contour Integration', path: '/cvla-m3-s6' },
    { name: 'System of linear equations', path: '/cvla-m7-s1' },
    { name: 'Eigen values and eigen vectors', path: '/cvla-m7-s2' },
    { name: 'Cayley Hamilton theorem', path: '/cvla-m7-s3' },
    { name: 'Vector Space', path: '/cvla-m4-s1' },
    { name: 'Basis and Dimension', path: '/cvla-m4-s2' },
    { name: 'Linear Transformation', path: '/cvla-m5-s1' },
    { name: 'Matrix Representation of Linear Transformation', path: '/cvla-m5-s2' },
    { name: 'Change of Basis', path: '/cvla-m5-s3' },
    { name: 'Inner Product Space', path: '/cvla-m6-s1' }
];

const CVLAModuleSubtopic = ({ title, videos, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_CVLA_SUBTOPICS, subjectPath = '/subject-CVLAModules' } = location.state || {};

    return (
        <ModuleSubtopic
            title={title}
            videos={videos}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_CVLA_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default CVLAModuleSubtopic;
